import { Check, Copy } from "lucide-react"
import { useState } from "react"
import { useErrorDialog } from "@/shared/components/ErrorDialog"
import { Button } from "@/shared/components/ui/button"
import { type Invite, useCreateInviteMutation } from "./api/children.mutations"

export function InviteSection({ childId }: { childId: string }) {
  const { showApiError } = useErrorDialog()
  const createInvite = useCreateInviteMutation()
  const [invite, setInvite] = useState<Invite | null>(null)
  const [copied, setCopied] = useState(false)

  const onGenerate = () => {
    createInvite.mutate(childId, {
      onSuccess: (result) => {
        setInvite(result)
        setCopied(false)
      },
      onError: (err) => showApiError(err, { title: "Kunde inte skapa inbjudan" }),
    })
  }

  const onCopy = async () => {
    if (!invite) return
    try {
      await navigator.clipboard.writeText(invite.code)
      setCopied(true)
    } catch (err) {
      showApiError(err, { title: "Kunde inte kopiera koden" })
    }
  }

  return (
    <section className="flex flex-col gap-3">
      <h2 className="text-sm font-medium text-muted-foreground">Bjud in vårdnadshavare</h2>
      {invite ? (
        <div className="flex flex-col items-center gap-2 rounded-lg border border-border p-4">
          <span className="font-mono text-3xl tracking-widest">{invite.code}</span>
          <span className="text-xs text-muted-foreground">Giltig i 48 timmar</span>
          <Button variant="outline" size="sm" onClick={onCopy}>
            {copied ? <Check /> : <Copy />}
            {copied ? "Kopierad" : "Kopiera kod"}
          </Button>
        </div>
      ) : (
        <Button variant="outline" onClick={onGenerate} isLoading={createInvite.isPending}>
          Bjud in vårdnadshavare
        </Button>
      )}
    </section>
  )
}
